import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getGroups } from "../actions/auth.js"
import Select_Dsas from "./Select_Dsas.js"

const SelectGroupProvider = ({value, onChange, disabled, className}) => {

    const dispatch = useDispatch()

    const groups = useSelector((state) => state.authentication).groups

    useEffect(() => {
        dispatch(getGroups())
    }, [])

    return (
    <Select_Dsas className={className} label='Groupe' name="provider" value={value} onChange={onChange} items={groups.sort((a,b) => a.name.localeCompare(b.name))} disabled={disabled}>
    </Select_Dsas>)

}

export default SelectGroupProvider